/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'

const Wrapper = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,0.2);
	z-index: 999999;
`
const WrapperSpin = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`
const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 68
    }}
    spin
  />
)

const Overlay = () => (
  <Wrapper>
    <WrapperSpin>
      <Spin indicator={antIcon} />
    </WrapperSpin>
  </Wrapper>
)

export default Overlay
